import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { setSelection, FlowType } from '../store/selectionSlice';

export default function useFlowInitialization(flowType: FlowType) {
  const dispatch = useDispatch();
  const currentFlow = useSelector((state: RootState) => state.selection.currentFlow);
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Reset index if different flow OR first mount of any flow
    if (!hasInitialized.current || currentFlow !== flowType) {
      dispatch(setSelection({
        currentIndex: 0,
        currentFlow: flowType,
        // Clear OTP verification when switching flows (security)
        otpVerificationCode: undefined
      }));
      hasInitialized.current = true;
    }
  }, [flowType, currentFlow, dispatch]);
}
